// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1qkVl","errorLogs":"EditorFooter_errorLogs__1f-Cj"};